export type MediaUploadInformation = {
  data: {
    url: string
    fields: Record<string, string>
  }
}

export enum MediaType {
  S3_VIDEO = "S3_VIDEO",
  S3_IMAGE = "S3_IMAGE",
  S3_PDF = "S3_PDF",
  YOUTUBE = "YOUTUBE",
  VIMEO = "VIMEO",
}

export type MediaItem = {
  url: string
  key: string | null
  type: MediaType
  filename: string | null
}
